const PHONETYPE = 'web';
const APPID = 'com.pokekara.web';

const GLOBAL_USER_RELATION_CHANGE = 'global_user_relation_change_event';
const GLOBAL_USER_MEMBERSHIP_CHANGE = 'global_user_membership_change_event';
const BROADCASTNAMES = {
    RewardTaskDidCompleteMVView: 'RewardTaskDidCompleteMVView',
    PokeRoomWebViewIconDataUpdated: 'PokeRoomWebViewIconDataUpdated',
    CacheHitCallBack: 'cache_hit_callback'
};
const config = {
    defaultUserCover: 'https://cdn.pokekara.com/int/webkara/pstatic/user.png',
    defaultMvCover: 'https://cdn.pokekara.com/int/webkara/pstatic/d_home_default.png',
    RELATIONSHIPFOLLOWED: 2,
    RELATIONSHIPNOFOLLOW: 0,
    RELATIONSHIPFOLLOW: 1,
    langMap: {
        ja_JP: 'ja',
        ja_CN: 'zh-hans'
    },
    JPLANGKEY: 'ja_JP',
    CNLANGKEY: 'ja_CN',
    PROTOCOL: 'https://cdn.pokekara.com/',
    UPLOADAPI: 'https://api-tc.pokekara.com/f/common/upload',
    WEBPROTOCOL: 'https://www.pokekara.com/',
    WEBSHAREPROTOCOL: 'https://u.pokekara.com/'
};
export {
    config,
    GLOBAL_USER_RELATION_CHANGE,
    GLOBAL_USER_MEMBERSHIP_CHANGE,
    PHONETYPE,
    APPID,
    BROADCASTNAMES
};
